import { useEffect, useState } from 'react';
import { message } from 'antd';
import { Address } from 'types';
import API from '../../API';

export const useAddresses = (clientId: number | undefined) => {
	const [addresses, setAddresses] = useState<Address[]>();

	useEffect(() => {
		if (!clientId) {
			setAddresses(undefined);
			return;
		}

		fetchAddresses(clientId);
	}, [clientId]);

	const fetchAddresses = async (clientId: number) => {
		try {
			const addresses = await API.addresses.getAll({ clientId });

			setAddresses(addresses);
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się pobrać danych (${e})`);
		}
	};

	return addresses;
};
